import { sendRequest } from "../ajax/ajax_es";
import { appendValidity, updateLoadMoreButton } from "./validity-filter";

export function initGridSort()
{
    const wrappers = document.getElementsByClassName('product-card-grid-wrapper');

    Array.prototype.forEach.call(wrappers, function (wrapper) {
        const buttons = wrapper.getElementsByClassName('grid-sort-button');

        Array.prototype.forEach.call(buttons, function (button) {
            const link = button.getAttribute('data-link');

            button.addEventListener('click', function () {
                gridSort(button, link, wrapper);
            });
        });
    });
}

function gridSort(button, link, wrapper) {
    const order = button.getAttribute('data-order');
    const column = button.getAttribute('data-col');

    const content = wrapper.getElementsByClassName('next-data-ph')[0];

    // Zachovat aktivní filtr platnosti (od-do) i při řazení.
    const url = appendValidity(link, content);

    sendRequest(url, function (xmlhttp) {
        const snippetResponse = xmlhttp.response;

        // Server signál zahodil (nepovolený sloupec nebo směr) - grid zůstává, jak byl.
        if (!snippetResponse.snippets) {
            return;
        }

        const snippet = Object.values(snippetResponse.snippets)[0];
        const dataBlock = wrapper.querySelector('.product-card-grid');

        dataBlock.innerHTML = snippet;

        // Stav řazení zapisujeme až tady, ať data-* nedrží řazení, které server nepoužil
        // (jinak by donačítání navázalo jiným řazením, než jakým je vykreslená 1. stránka).
        content.setAttribute('data-order', order);
        content.setAttribute('data-col', column);

        // Řazení překresluje grid od 1. stránky (server posílá page=null). Šipka i data-page jsou mimo snippet,
        // takže je musíme srovnat ručně - jinak po předchozím donačtení zůstane data-page vysoké a šipka skrytá.
        dataBlock.setAttribute('data-page', '1');
        updateLoadMoreButton(wrapper, dataBlock);

        setActiveSortButton(wrapper, button);
    });
}

function setActiveSortButton(wrapper, activeButton) {
    const buttons = wrapper.getElementsByClassName('grid-sort-button');

    Array.prototype.forEach.call(buttons, function (button) {
        button.classList.toggle('active', button === activeButton);
    });
}
